import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';
import { PartnerApiService, PartnerModelApiService, SubscriptionTiersApiService } from '@vendasta/partner';
import { GetUpdateSubscriptionTierStatusResponse } from '@vendasta/partner';
import {
  BillingFrequency,
  SubscriptionTierUpdateType,
  UpdateSubscriptionTierRequestInterface,
} from '@vendasta/partner';
import { InitiateSubscriptionTierUpdateRequestInterface } from '@vendasta/partner/lib/_internal/interfaces';

@Injectable({ providedIn: 'root' })
export class PartnerSubscriptionService {
  constructor(
    private api: PartnerApiService,
    private partnerModelService: PartnerModelApiService,
    private subscriptionTierService: SubscriptionTiersApiService,
  ) {}

  updateSubscriptionTier(
    partnerId: string,
    tierId: string,
    frequency: BillingFrequency,
    updateType: SubscriptionTierUpdateType,
  ): Observable<boolean> {
    const request = {
      partnerId: partnerId,
      tierId: tierId,
      frequency: frequency,
      updateType: updateType,
    } as UpdateSubscriptionTierRequestInterface;
    return this.api.updateSubscriptionTier(request).pipe(map((resp: HttpResponse<null>) => resp.ok));
  }

  getUpdateSubscriptionTierStatus(partnerId: string): Observable<GetUpdateSubscriptionTierStatusResponse> {
    const request = { partnerId: partnerId };
    return this.api.getUpdateSubscriptionTierStatus(request);
  }

  initiateSubscriptionTierUpdate(partnerId: string, tierId: string): Observable<boolean> {
    const request = {
      partnerId: partnerId,
      tierId: tierId,
    } as InitiateSubscriptionTierUpdateRequestInterface;
    return this.api.initiateSubscriptionTierUpdate(request).pipe(map((resp: HttpResponse<null>) => resp.ok));
  }

  canAccessFeature(feature: string, partnerId: string): Observable<boolean> {
    return this.partnerModelService.getPartnerModel({ partnerId: partnerId }).pipe(
      switchMap((partnerModel) =>
        this.subscriptionTierService.getSubscriptionTier({ id: partnerModel.partner.subscriptionTierId }),
      ),
      map((subscriptionTier) => {
        return !!subscriptionTier.subscriptionTier.enabledFeatures.find((feat) => feat === feature);
      }),
    );
  }
}
